import React from 'react';
import GeneralLayout from '_containers/Layout/GeneralLayout';
import './styles.scss';

const componentBaseClass = 'qoc-404-page';

function FourOhFourPage(props = {}) {
  console.log('-- FourOhFourPage props: ', props);

  return (
    <GeneralLayout>
      <div className={componentBaseClass}>
        <h1>404</h1>
        <p>Page Not Found</p>
        <p>It looks like the page you’re trying to reach no longer exists.</p>
        <p>We apologize for the inconvenience.</p>
        <p>
          Please{' '}
          <a
            rel="noopener noreferrer"
            href="https://easthma.ca/contact_us_clinicians"
            target="_blank"
          >
            Contact Us
          </a>{' '}
          to report this error. 
        </p>
      </div>
    </GeneralLayout>
  );
}

FourOhFourPage.propTypes = {};
FourOhFourPage.defaultProps = {};

export default FourOhFourPage;
